import { render, staticRenderFns } from "./ReportModalAssetChip.vue?vue&type=template&id=6452195a&"
import script from "./ReportModalAssetChip.vue?vue&type=script&lang=js&"
export * from "./ReportModalAssetChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports